module.exports = __webpack_public_path__ + "img/g9.8a17d523.jpg";